/** Customer storefront — SEO preview links in admin only (not API calls). */
export const customerSiteURL = "https://gobooze.com.au";

// LIVE URL
export const baseURL = "https://api.gobooze.com.au/admin";
export const productBaseURL = "https://api.gobooze.com.au/product/v1";
export const variantsBaseURL = "https://api.gobooze.com.au/product/v1/variants";
export const orderURL = "https://api.gobooze.com.au/order/api/orders";
export const imageURL = "https://gobooze-tst-new.s3.ap-southeast-2.amazonaws.com/goboozestore/";
export const socketURL = "https://api.gobooze.com.au";
export const GOOGLE_MAP_API_KEY = "AIzaSyCtTH8DV1-h4tYTSb-geYjdn71a0Up_63k";

// // de URL
// export const baseURL = "https://gobooze-test.codefactstech.com/admin";
// export const productBaseURL = "https://gobooze-test.codefactstech.com/product/v1";
// export const variantsBaseURL = "https://gobooze-test.codefactstech.com/product/v1/variants";
// export const orderURL = "https://gobooze-test.codefactstech.com/order/api/orders";
// export const imageURL = "https://gobooze-tst-new.s3.ap-southeast-2.amazonaws.com/goboozestore/";
// export const socketURL = "https://gobooze-test.codefactstech.com";
// export const GOOGLE_MAP_API_KEY = "AIzaSyCtTH8DV1-h4tYTSb-geYjdn71a0Up_63k";


// LOCAL URL
// export const baseURL = 'http://localhost:9000';
// export const productBaseURL = "http://localhost:9000/v1";
// export const variantsBaseURL = "http://localhost:9000/v1/variants";
// export const orderURL = 'http://localhost:9000/api/orders';
